<template>
    <div class="row">
        <div class="col-sm-12">
            <form autocomplete="off" method="post" data-vv-scope="form"
                @keyup.enter="() => {}"
                @submit.prevent="onBeforeSaveItem">
                <div class="row mb-3">
                    <div class="col-sm-auto">
                        <h1 class="content-title">{{ titleItem }}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-name"
                                name="name"
                                v-model.trim="form.name"
                                v-validate="'required|min:3'"
                                :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                :error=" fnFirstError('name')">
                                {{ $t(`${pageID}.model.name`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-status"
                                name="status"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.status"
                                :reduce="option => option.code"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('status') }]"
                                :error=" fnFirstError('status')">
                                {{ $t(`${pageID}.model.status`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="lists.channels.length">
                    <div class="col-12">
                        <div class="form-group">
                            <label class="city-label">{{ $t(`${pageID}.model.channel_id`) }}</label>
                            <div class="d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap">
                                <div class="form-check city-form-check"
                                    :class="[{'is-invalid': fnHasError(`channel`) }]"
                                    v-for="channel in lists.channels"
                                    :key="`channel-${channel.id}`">
                                    <input class="form-check-input"
                                        type="radio"
                                        :disabled="readonlyFormItem"
                                        v-model="form.channel_id"
                                        :value="channel.id"
                                        :id="`cb-channel-${channel.id}`"
                                        :name="`channel`"
                                        v-validate="{required: true}"
                                        >
                                    <label class="form-check-label" :for="`cb-channel-${channel.id}`">
                                        {{ channel.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label class="city-label">{{ $t(`${pageID}.model.targets`) }}</label>
                            <div class="d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap">
                                <div class="form-check city-form-check"
                                    :class="[{'is-invalid': fnHasError(`targets`) }]"
                                    v-for="target in lists.targets"
                                    :key="`target-${target.id}`">
                                    <input class="form-check-input"
                                        type="checkbox"
                                        :disabled="readonlyFormItem"
                                        v-model="form.targets"
                                        :value="target"
                                        :id="`cb-target-${target.id}`"
                                        :name="`targets`"
                                        v-validate="{required: isAutomatic}"
                                        >
                                    <label class="form-check-label" :for="`cb-target-${target.id}`">
                                        {{ target.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg"
                                id="input-automatic"
                                name="automatic"
                                label="name"
                                :filterable="true"
                                :options="lists.onoff"
                                v-model.trim="form.automatic"
                                :reduce="option => option.code"
                                v-validate="'required'"
                                :inputClasses="[{'is-invalid': fnHasError('automatic') }]"
                                :error=" fnFirstError('automatic')">
                                {{ $t(`${pageID}.model.automatic`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyFormItem"
                                type="text"
                                class="city-form-group city-bg"
                                id="input-subject"
                                name="subject"
                                v-model.trim="form.subject"
                                v-validate="getRule('subject')"
                                :inputClasses="[{'is-invalid': fnHasError('subject') }]"
                                :error=" fnFirstError('subject')">
                                {{ $t(`${pageID}.model.subject`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12" v-if="isAutomatic">
                        <div class="form-group">
                            <MaterialSelect
                                :disabled="readonlyFormItem"
                                class="city-form-group city-bg my-0"
                                id="input-triggers"
                                name="triggers"
                                label="name"
                                :filterable="false"
                                :options="lists.triggers"
                                :reduceObject="true"
                                :multiple="true"
                                v-model.trim="form.triggers"
                                v-validate="{required: isAutomatic}"
                                :inputClasses="[{'is-invalid': fnHasError('triggers') }]"
                                :error=" fnFirstError('triggers')"
                                track-by="id">
                                {{ $t(`${pageID}.model.triggers`) }}
                            </MaterialSelect>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label class="city-label">{{ $t(`${pageID}.model.message`) }}</label>
                            <template v-if="readonlyFormItem">
                                <div v-html="form.message"></div>
                            </template>
                            <template v-else>
                                <div class="city-form-group" :class="{'is-invalid': fnHasError('message') }">
                                    <ckeditor
                                        v-model="form.message"
                                        :disabled="readonlyFormItem"
                                        :editor="cKEditor.editor"
                                        :config="cKEditor.editorConfig">
                                    </ckeditor>
                                    <input type="hidden" name="message" v-model="form.message" v-validate="getRule('message')">
                                    <small v-if="fnFirstError('message')"
                                        class="d-block invalid-feedback">
                                        {{ fnFirstError('message') }}
                                    </small>
                                    <help-span :helpText="txtHelpTextMessage" />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!readonlyFormItem">
                    <div class="col-12">
                        <div class="form-group">
                            <p class="city-label">
                                <a class="btn btn-main btn-rounded z-depth-0 m-0 collapsed"
                                    data-toggle="collapse"
                                    href="#collapseTags"
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls="collapseTags">
                                    {{ $t(`${pageID}.model.tags`) }}
                                </a>
                            </p>
                            <div class="collapse" id="collapseTags">
                                <div class="row">
                                    <div class="col"
                                        v-for="tag in lists.tags"
                                        :key="`tag-${tag.id}`">
                                        <div class="form-group">
                                            <p class="tag cursor-pointer mb-0"
                                                data-toggle="tooltip-city"
                                                data-placement="bottom"
                                                :title="txtTitleCopyTag"
                                                @click.prevent="copyToClipboard($event, '{{'+tag.name+'}}')" v-text="'{{'+tag.name+'}}'">
                                            </p>
                                            <small class="form-text text-muted">
                                                {{ tag.descr }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <buttons-footer
                    :enableButtons="!readonlyFormItem"
                    :cancelTitle="cancelTitle"
                    :submitTitle="submitTitle"
                    :isDisabled="isDisabled"
                    @save="onBeforeSaveItem"
                    @cancel="handleBack"
                >
                </buttons-footer>
            </form>
        </div>
    </div>
</template>

<script>

import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';
import DetailsMixin from './mixins/DetailsMixin';
import {isArray} from '@config/utils';

export default {
    name: 'ManageNotificationDetails',
    mixins: [
        DetailsMixin,
        CkEditorConfigMixin,
    ],
    props: {
        componentId: {
            type: String,
            require: true,
        },
        titleCopyTag: {
            type: String,
            default: 'form.tag.copy_title',
        },
        titleCopiedTag: {
            type: String,
            default: 'form.tag.copied_title',
        },
        helpTextMessage: {
            type: String,
            default: 'form.msg.help',
        },
    },
    data() {
        return {
            pageID: null,
            pageTitle: 'Details',
            form: {
                id: null,
                name: null,
                subject: null,
                message: '',
                automatic: 0,
                channel_id: null,
                status: 1,
                triggers: [],
                targets: [],
            },
            lists: {
                channels: [],
                targets: [],
                triggers: [],
                tags: [],
            },
        }
    },
    beforeMount() {
        this.pageID = this.componentId;
    },
    computed: {
        plainMessage() {
            return this.form.message ? this.form.message.replace(/<[^>]*>?/gm, '') : null;
        },
        channel() {
            return this.lists.channels.find(c => c.id == this.form.channel_id);
        },
		channelRules() {
			if(!this.channel) return {};
			const vetRules = this.channel.front_validation.split(/\r?\n/);
			if(vetRules.length <= 0) return {};
			let rules = {};
			vetRules.forEach(item => {
				const field = item.replace(/([^:]*).*/, '$1');
				const rule = item.replace(/[^:]*:(.*)/, '$1');
				rules[field] = rule;
			});
			return rules;
		},
        activeSubjectField() {
            return this.channel ? (this.channel.fields &&  isArray(this.channel.fields) ? this.channel.fields.includes('subject') : false) : true;
        },
        txtTitleCopyTag() {
            return this.$t(`${this.pageID}.${this.titleCopyTag}`);
        },
        txtTitleCopiedTag() {
            return this.$t(`${this.pageID}.${this.titleCopiedTag}`);
        },
        txtHelpTextMessage() {
            return this.$t(`${this.pageID}.${this.helpTextMessage}`);
        },
        isAutomatic() {
            return !!this.form.automatic;
        },
    },
    methods: {
		getRule(field) {
			return this.channelRules[field] != undefined ? this.channelRules[field] : '';
		},
        setDefaultChannel() {
            if(!this.form.id && this.lists.channels && this.lists.channels.length==1) {
                this.form.channel_id = this.lists.channels[0].id;
            }
        },
        copyToClipboard: function(event, input) {
            const cssText = 'position:fixed;pointer-events:none;z-index:-9999;opacity:0;'
            const copyErrorMessage = 'Failed to copy value to clipboard. Unknown type.'
            let value;
            if (typeof input !== 'string') {
                try {
                    value = JSON.stringify(input)
                } catch (e) {
                    throw copyErrorMessage;
                }
            } else {
                value = input;
            }

            const textarea = document.createElement('textarea');
            textarea.value = value;
            textarea.setAttribute('readonly', '');
            textarea.style.cssText = cssText;
            document.body.appendChild(textarea);

            if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                textarea.contentEditable = true;
                textarea.readOnly = true;

                const range = document.createRange();
                range.selectNodeContents(textarea);

                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                textarea.setSelectionRange(0, 999999);
            } else {
                textarea.select();
            }

            let success = false;
            try {
                success = document.execCommand('copy');
            } catch (err) {
                console.warn(err);
            }

            document.body.removeChild(textarea);

            if(success){
                $(event.target)
                    .addClass("animated bounceIn")
                    .tooltip('hide')
                    .attr('data-original-title', this.txtTitleCopiedTag)
                    .tooltip('show');

                setTimeout(()=>{
                    $(event.target)
                        .removeClass("animated bounceIn")
                        .tooltip('hide')
                        .attr('data-original-title', this.txtTitleCopyTag);
                }, 1000);
            }
            return success;
        },
        onBeforeSaveItem() {
            this.saveItem(`${this.moduleCode}.${this.pageID}`);
        },
    },
    watch: {
        'lists.channels': {
            deep: true,
            handler(newValue, oldValue){
                this.setDefaultChannel();
            }
        }
    },
}
</script>

<style scoped lang="scss">
    @import "@styles/_theme.scss";
    .tag {
        &:hover {
            color: $link-text-color;
        }
    }
</style>